import React from 'react';
import PropTypes from 'prop-types';
import TrcSummaryTable from './TrcSummaryTable';
import { generateReactKey } from '../../../../../../utils/shared/commonUtils';
import { TITLE } from '../../../../../../constants/shared/CommonConstants';

const TrcTables = ({ results, openProbeDetails, summeryLabel }) => {
    return results.map(({ period, result, books }) =>
        result ? (
            <TrcSummaryTable
                key={generateReactKey(period)}
                period={period}
                isPresumed={result.isPresumed}
                books={books}
                resultId={result.resultId}
                openProbeDetails={openProbeDetails}
                summeryLabel={summeryLabel}
            />
        ) : (
            <TrcSummaryTable
                key={generateReactKey(period)}
                period={period}
                summeryLabel={summeryLabel}
            />
        ),
    );
};

TrcTables.defaultProps = {
    results: [],
    studentId: '',
    summeryLabel: TITLE.SUMMER_TITLE,
};

TrcTables.propTypes = {
    results: PropTypes.arrayOf(PropTypes.object),
    studentId: PropTypes.string,
    openProbeDetails: PropTypes.func.isRequired,
    summeryLabel: PropTypes.string,
};

export default TrcTables;
